import React from 'react';
import { Text, View } from 'react-native-web';
import PropTypes from 'prop-types';

// Configs
import GLOBAL from '../../configs/config_global';

export default function SectionContainer(props) {
    // region Props
    const {
        title,
        description,
        boldDescription,
        style,
        embeddedMode,
        showTopBorder,
        showBottomBorder,
        isMandatory
    } = props;
    // endregion

    // region MAIN RENDER
    return(
        <View style={[
            { alignSelf: 'stretch', backgroundColor: 'white' },
            !embeddedMode && { borderTopWidth: showTopBorder ? 1 : 0, borderBottomWidth: showBottomBorder ? 1 : 0, borderColor: GLOBAL.COLOR.DIVIDER, marginTop: 16, padding: 24 }
        ].concat(style)}>
            {/* Title / Description */}
            <View style={{ alignSelf: 'stretch' }}>
                <View style={{ alignSelf: 'stretch', flexDirection: 'row', alignItems: 'center' }}>
                    {/* Title */}
                    <Text style={{ fontSize: 24, fontWeight: 'bold', color: 'black' }}>
                        {title}
                    </Text>

                    {
                        isMandatory &&
                        <Text style={{ fontSize: 20, color: GLOBAL.COLOR.BASIC.RED }}> *</Text>
                    }
                </View>

                {/* Description */}
                {
                    !!description?.trim() &&
                    <Text style={{ color: GLOBAL.COLOR.TEXT_LIGHT_GRAY, fontSize: 16, fontWeight: 'normal', marginTop: 16, alignSelf: 'stretch' }}>
                        {description}<b>{boldDescription}</b>
                    </Text>
                }
            </View>

            {/* Children */}
            <View style={{ marginTop: 16 }}>
                {props.children}
            </View>
        </View>
    )
    // endregion
}

// region Props
SectionContainer.propTypes = {
    title: PropTypes.string,
    description: PropTypes.string,
    boldDescription: PropTypes.string,
    style: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
    embeddedMode: PropTypes.bool,
    showTopBorder: PropTypes.bool,
    showBottomBorder: PropTypes.bool,
    isMandatory: PropTypes.bool
}

SectionContainer.defaultProps = {
    title: 'Section',
    description: '',
    boldDescription: '',
    style: {},
    embeddedMode: false,
    showTopBorder: false,
    showBottomBorder: false,
    isMandatory: false
}
// endregion
